const locales = {
  en: "en_US",
  es: "es_ES",
  pt: "pt_BR",
  ru: "ru_RU",
  fr: "fr_FR",
  de: "de_DE",
  cn: "zh_CN",
  jp: "ja_JP"
};
var pathName = window.document.location.pathname;
var hostName = window.document.location.hostname;
if (hostName === "www.fotor.com" || hostName === "test-www.fotor.com") {
  hostName = ".fotor.com";
}
//hostName = ".fotor.com";
let locale = "en";
function setCookie(name, value) {
  var exp = new Date();
  exp.setTime(exp.getTime() + 60 * 60 * 24 * 30 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/;domain=" + hostName;
}
if (pathName.indexOf("/") !== -1 && pathName !== "/") {
  let temp = pathName.split("/");
  locale = temp.length >= 2 ? temp[1] : "en";
}

locales[locale] ? setCookie("locale", locales[locale]) : setCookie("locale", locales["en"]);
locales[locale]
  ? setCookie("clientLocale", locales[locale])
  : setCookie("clientLocale", locales["en"]);
